import { datadogRum, type RumErrorEvent } from '@datadog/browser-rum';

export default defineNuxtPlugin(() => {
    datadogRum.init({
        applicationId: '7f840ec1-2484-4edd-87cd-d7caa1dd07e5',
        clientToken: 'pub6c9ed812997c49ed1484482783d563c7',
        site: 'datadoghq.eu',
        service: 'cavu-workspaces',
        env: process.env.NODE_ENV,
        version: process.env.NUXT_ENV_JOB_ID,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        enablePrivacyForActionName: true,
        defaultPrivacyLevel: 'mask-user-input',
        beforeSend: (event) => {
            if (event.error) {
                const error = (event as RumErrorEvent).error;
                const regex = /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/;
                if (regex.test(error.message)) return false;
            }
            return true;
        },
    });
});
